import { ApolloProvider } from '@apollo/client';
import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@gasbuddy/react-components';
import { I18nextProvider } from 'react-i18next';
import client from './graphql/client';
import Router from '../common/router';
import appI18n from './i18n';

export default function renderApp() {
  const container = document.getElementById('root');
  const supportsHistory = 'pushState' in window.history;

  const render = (Component) => (
    hydrateRoot(container, (
      <ApolloProvider client={client}>
        <HelmetProvider>
          <I18nextProvider i18n={appI18n}>
            <BrowserRouter forceRefresh={!supportsHistory}>
              <ThemeProvider theme="next">
                <Component />
              </ThemeProvider>
            </BrowserRouter>
          </I18nextProvider>
        </HelmetProvider>
      </ApolloProvider>
    ))
  );

  render(Router);
}
